import React, { useEffect, useState } from 'react';
import logoImg from '../img/logo.png';
import { formatPrice, getWeb3 } from '../helper/functions';
import { DECIMALS, DEFAULT_CHAIN, SYMBOL, contract } from '../helper/constant';
import stakeAbi from '../json/bscstake.json';
import tokenAbi from '../json/token.json';
import { useAccount, useNetwork } from 'wagmi';
import { useEthersSigner } from '../hooks/useEthersProvider';
import { getContract } from '../helper/contractHelper';
import { toast } from 'react-toastify';
import { useWeb3Modal } from '@web3modal/react';
import { ethers } from 'ethers';
import { useLocation } from 'react-router-dom';
import Loading from './Loading';
import MyWallet from './MyWallet';
import TabButton from './TabButton';
import Slider from 'react-rangeslider'
import 'react-rangeslider/lib/index.css';


export default function Stake({ commonStats, accStats, setUpdater, setTab, tab }) {
    const { address, isConnected } = useAccount()
    const { chain } = useNetwork();
    const signer = useEthersSigner()
    const { open } = useWeb3Modal()
    const [amountkey, setAmountkey] = useState(0);
    const [amount, setAmount] = useState(0);
    const [days, setDays] = useState(0);
    const [durationIndex, setDurationIndex] = useState(0);
    // const [apy, setApy] = useState(0);
    // const [ereturn, setEreturn] = useState(0);
    // const [endTime, setEndTime] = useState(0);
    let web3 = getWeb3(DEFAULT_CHAIN);
    // const timenow = Math.floor(new Date().getTime() / 1000.0);
    const [loading, setLoading] = useState(false);
    const [refAddress, setRefAddress] = useState('');
    const search = useLocation().search;

    useEffect(() => {
        let refAddr = '';
        const queryChainId = new URLSearchParams(search).get('ref');
        if (queryChainId !== '') {
            refAddr = queryChainId;
        }
        setRefAddress(refAddr);
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        async function fetch() {
            try {

                let stakeContract = new web3.eth.Contract(stakeAbi, contract[DEFAULT_CHAIN].STAKE_ADDRESS);
                let tamount = commonStats.stakeAmounts[amountkey];
                let tokenAmount = await stakeContract.methods.getAmountsOut(tamount).call();
                // let perSecR = await stakeContract.methods.accurateInterest(tokenAmount, commonStats.stakeApys[durationIndex], commonStats.stakeDays[durationIndex]).call();

                setAmount(parseFloat(tokenAmount / Math.pow(10, DECIMALS)));
                // setApy(commonStats.stakeApys[amountkey] / 100);
                setDays(commonStats.stakeDays[durationIndex]);
                // setEreturn(perSecR[1] / Math.pow(10, DECIMALS));
                // setEndTime((parseInt(timenow) + parseInt(commonStats.stakeDays[durationIndex])));
            }
            catch (err) {
                console.log(err.message);
            }
        }

        fetch();
        // eslint-disable-next-line
    }, [amountkey, durationIndex, commonStats])

    const handleApprove = async () => {
        if (address) {
            if (chain.id === DEFAULT_CHAIN) {
                try {

                    setLoading(true);

                    let tokenContract = getContract(tokenAbi, contract[DEFAULT_CHAIN].TOKEN_ADDRESS, signer);
                    let amount1 = ethers.utils.parseEther('1000000000000').toString();

                    let tx = await tokenContract.approve(contract[DEFAULT_CHAIN].STAKE_ADDRESS, amount1, { 'from': address });
                    const resolveAfter3Sec = new Promise(resolve => setTimeout(resolve, 5000));
                    toast.promise(
                        resolveAfter3Sec,
                        {
                            pending: 'Waiting for confirmation',
                        }
                    )

                    var interval = setInterval(async function () {
                        let web3 = getWeb3(DEFAULT_CHAIN);
                        var response = await web3.eth.getTransactionReceipt(tx.hash);
                        if (response != null) {
                            clearInterval(interval)
                            if (response.status === true) {
                                toast.success('success ! your last transaction is success 👍');
                                setLoading(false);
                                setUpdater(Math.random());
                            }
                            else if (response.status === false) {
                                toast.error('error ! Your last transaction is failed.');
                                setLoading(false);
                                setUpdater(Math.random());
                            }
                            else {
                                toast.error('error ! something went wrong.');
                                setLoading(false);
                                setUpdater(Math.random());
                            }
                        }
                    }, 5000);
                }
                catch (err) {
                    console.log(err.message)
                    toast.error(err.reason ? err.reason : err.message);
                    setLoading(false);
                }
            }
            else {
                toast.error('Please select Binance Mainnet Network !');
                setLoading(false);
            }

        }
        else {
            toast.error('Please Connect Wallet!');
            setLoading(false);
        }
    }

    const handleStake = async () => {
        setLoading(true);
        try {

            if (address && isConnected) {
                if (chain.id === DEFAULT_CHAIN) {

                    if (parseFloat(accStats.stakeTokenBalance) >= parseFloat(amount)) {

                        let tokenStakingAddress = contract[DEFAULT_CHAIN].STAKE_ADDRESS;
                        let stakeContract = getContract(stakeAbi, tokenStakingAddress, signer);
                        let refAddr = refAddress ? refAddress : '0x0000000000000000000000000000000000000000';

                        let tx = await stakeContract.stake(amountkey, durationIndex, refAddr, { 'from': address });
                        const resolveAfter3Sec = new Promise(resolve => setTimeout(resolve, 5000));
                        toast.promise(
                            resolveAfter3Sec,
                            {
                                pending: 'Waiting for confirmation 👌',
                            }
                        )

                        var interval = setInterval(async function () {
                            let web3 = getWeb3(DEFAULT_CHAIN);
                            var response = await web3.eth.getTransactionReceipt(tx.hash);
                            if (response != null) {
                                clearInterval(interval)
                                if (response.status === true) {
                                    toast.success('success ! your last transaction is success 👍');
                                    setUpdater(Math.random());
                                    setLoading(false);
                                }
                                else if (response.status === false) {
                                    toast.error('error ! Your last transaction is failed.');
                                    setUpdater(Math.random());
                                    setLoading(false);
                                }
                                else {
                                    toast.error('error ! something went wrong.');
                                    setUpdater(Math.random());
                                    setLoading(false);
                                }
                            }
                        }, 5000);

                    }
                    else {
                        toast.error('you don\'t have enough balance !');
                        setLoading(false);
                    }

                }
                else {
                    toast.error('Please select Binance Mainnet Network !');
                    setLoading(false);
                }
            }
            else {
                toast.error('Please Connect Wallet!');
                setLoading(false);
            }

        }
        catch (err) {
            toast.error(err.reason);
            setLoading(false);
        }
    }

    const sliderOnChange = value => {
        if (value !== 0) {
            const index = commonStats.stakeDays.findIndex(rowdata => parseInt(rowdata) === parseInt(value));
            if (index !== -1) setDurationIndex(index);
        }
    };

    return (
        <div>
            <div className='row mb-4'>
                <div className='col-12 col-xl-8'>
                    <div className='d-flex justify-content-center row'>
                        <TabButton setTab={setTab} tab={tab} />
                        <div className='col-12 col-xl-9'>
                            <div className='row'>
                                <div className='col-sm-12 col-xl-12 col-lg-12 mb-2 mb-md-3 text-center'>
                                    {commonStats && commonStats.stakeAmounts && commonStats.stakeAmounts.length > 0 ? (
                                        commonStats.stakeAmounts.map((value, key) => {
                                            return (
                                                <button type='button' onClick={() => setAmountkey(key)} className={`btn ${key === amountkey ? 'btn-warning' : 'btn-warning-info bg-dark-1'} btn-amounts  my-2 mx-1 mb-md-0`}>
                                                    ${formatPrice(value / Math.pow(10, DECIMALS))}
                                                </button>

                                            )
                                        })
                                    ) : (
                                        <Loading />
                                    )
                                    }
                                </div>
                                <div className='col-12 mt-1 mt-md-3  mb-3'>
                                    <div class="add-liquidity mt-3 mob-margin">
                                        <div class="content-stake">
                                            <div class="d-flex align-items-center justify-content-between">
                                                <div class="labels"><h6>{SYMBOL}</h6></div>
                                                <div class="labels1">
                                                    <input type="text" readonly={true} value={formatPrice(amount)} />
                                                </div>
                                                <div>
                                                    <img src={logoImg} class="icon-img" alt="icon" />
                                                </div>
                                            </div>
                                            <p class="text-danger error-text"><small></small></p>
                                        </div>
                                    </div>
                                </div>
                                <Slider
                                    progress
                                    min={0}
                                    step={15552000}
                                    max={93312000}
                                    defaultValue={15552000}
                                    tooltip={true}
                                    value={days}
                                    format={value => `${parseInt(value / 2592000)} Month`}
                                    onChange={sliderOnChange}
                                    className="mb-5"
                                />

                                <div className='col-12 text-center d-flex d-md-block'>

                                    {commonStats && commonStats.stakeDays && commonStats.stakeDays.length > 0 ? (
                                        commonStats.stakeDays.map((rowdata, key) => {
                                            return (
                                                <button className={`btn ${parseInt(days) === parseInt(rowdata) ? 'btn-warning' : 'btn-warning-info bg-dark-1'} btn-periods mx-1 mb-3 mb-md-0`} onClick={() => {
                                                    setDays(rowdata)
                                                    setDurationIndex(key);
                                                }}>
                                                    {parseInt(rowdata / 2592000)} Month
                                                    {/* {parseInt(rowdata / 3600)} Hour */}
                                                </button>
                                            )
                                        })
                                    ) : (
                                        <Loading />
                                    )
                                    }
                                </div>
                            </div>
                        </div>

                        {/* <div className='col-12 col-xl-9 mt-5 text-white'>
                            <div className='d-flex justify-content-around align-items-center text-center mb-3'>

                                <div className='bg-dark-1 px-1 py-2 px-md-3 py-md-2'>
                                    <p className='text-yellow text-small mb-0'>APY : <span className='text-white'>{apy ? apy : 0}%</span></p>
                                </div>
                                <div className='bg-dark-1 px-1 py-2 px-md-3 py-md-2'>
                                    <p className='text-yellow text-small mb-0'>Lock : <span className='text-white'>
                                        {days ? parseInt(days / (86400)) : '-'} Days</span>
                                    </p>
                                </div>
                                <div className='bg-dark-1 px-1 py-2 px-md-3 py-md-2'>
                                    <p className='text-yellow text-small mb-0'>Return : <span className='text-white'>
                                        {ereturn ? `${formatPrice(ereturn, 6)} ${commonStats.tokenSymbol ? commonStats.tokenSymbol : ''}` : '-'}</span>
                                    </p>
                                </div>
                                <div className='bg-dark-1 px-1 py-2 px-md-3 py-md-2'>
                                    <p className='text-yellow text-small mb-0'>Unlock : <span className='text-white'>
                                        {endTime ? shorterDate(endTime * 1000, true) : ' - '}</span>
                                    </p>
                                </div>
                            </div>

                        </div> */}

                    </div>

                    <div className='col-12 d-flex justify-content-center align-items-center mt-5'>
                        {
                            address && isConnected ? (
                                parseFloat(accStats.stakeTokenBalance) >= parseFloat(amount) ? (
                                    parseFloat(accStats.isApproved) >= parseFloat(amount) ? (
                                        <button className="btn btn-warning ms-4 btn-lg btn-full" disabled={loading} onClick={() => !loading ? handleStake() : null}>{loading ? 'Loading…' : 'Invest Now'}</button>
                                    ) : (
                                        <button className="btn btn-warning ms-4 btn-lg btn-full" disabled={loading} onClick={() => !loading ? handleApprove() : null}>{loading ? 'Loading…' : 'Approve'}</button>
                                    )) : (
                                    <button className="btn btn-warning ms-4 btn-lg btn-full" disabled={true}>Approve</button>
                                )
                            ) : (
                                <button className="btn btn-warning ms-4 btn-lg btn-full" onClick={() => open()} >Connect Wallet</button>
                            )
                        }
                    </div>

                </div>

                <MyWallet accStats={accStats} />


            </div>

        </div>
    )
}
